export const buildTime = '2026-09-18 09:35:34 UTC';
